import { GetAllPlannedBreaks } from "hooks/apollo/plannedBreak/plannedBreak.gql";
import filter from "lodash/filter";

export function insertPlannedBreak(newPlannedBreak, proxy) {
  const plannedBreaks = read(proxy);

  const updatedPlannedBreaks = [newPlannedBreak].concat(
    filter(plannedBreaks, (existingPlannedBreak) => existingPlannedBreak.id !== newPlannedBreak.id),
  );

  write(updatedPlannedBreaks, proxy);
}

export function removePlannedBreak(plannedBreakId, proxy) {
  const internalPlannedBreak = proxy.identify({ __typename: "PlannedBreak", id: plannedBreakId });
  proxy.evict({ id: internalPlannedBreak });
  proxy.gc();
}

function read(proxy) {
  const { plannedBreaks } = proxy.readQuery({ query: GetAllPlannedBreaks });

  return plannedBreaks;
}

function write(plannedBreaks, proxy) {
  proxy.writeQuery({
    data: { plannedBreaks },
    query: GetAllPlannedBreaks,
  });
}
